import LeadEdit from '_modules/lead/views/LeadEdit.vue';
import LeadList from '_modules/lead/views/LeadList.vue';
import Lead from './Root.vue';


export default {
  path: 'indicacoes/',
  component: Lead,
  name: 'admin-lead',
  redirect: '/indicacoes/lista/1',
  children: [
    {
      path: 'lista/:page',
      name: 'admin-lead-list',
      component: LeadList,
    },
    {
      path: ':leadId',
      name: 'admin-lead-edit',
      component: LeadEdit,
    },
  ],
};
